/** localStorage key — must match ThemeProvider `storageKey`. */
export const THEME_STORAGE_KEY = "wm-theme";
